import { render } from "./FullReduction.vue?vue&type=template&id=7f6f3d6f"
import script from "./FullReduction.vue?vue&type=script&lang=js"
export * from "./FullReduction.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__